import { Common, color, Widget } from '@stockbit/ui';
import { ChangeEvent, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import slice, { effects, selectors } from './slice';
import { Modal } from '../styled';

const { Text, Input, Flex } = Common;
const { Button } = Widget;

const { actions } = slice;

const Title = (
  <Text size="16px" align="center" height="40px" family="bold">
    Create New Watchlist
  </Text>
);

function CreateModal() {
  const dispatch = useDispatch();
  const { isCreateModalVisible } = useSelector(selectors);

  const [watchlistName, setWatchlistName] = useState<string>('');

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    setWatchlistName(e.target.value);
  };

  const handleSubmitWatchlistName = async (e) => {
    e?.preventDefault();

    if (watchlistName.length > 0) {
      dispatch(actions.toggleCreateModal({}));
      await dispatch(effects.createNewWatchlist({ name: watchlistName }));
    }
  };

  const handleModalCancel = () => {
    dispatch(actions.toggleCreateModal({}));
  };
  return (
    <Modal
      title={Title}
      visible={isCreateModalVisible}
      onCancel={handleModalCancel}
      centered
      footer={null}
    >
      <form onSubmit={handleSubmitWatchlistName}>
        <Text
          as="label"
          htmlFor="wl-name"
          mb="8px"
          style={{ display: 'block' }}
        >
          Watchlist Name
        </Text>
        <Input
          id="wl-name"
          placeholder="Type Watchlist Name..."
          height="40px"
          width="100%"
          onChange={handleOnChange}
          value={watchlistName}
          suffix={watchlistName.length + '/25'}
          maxLength={25}
        />
        <input type="submit" style={{ display: 'none' }} />
      </form>
      <Flex justify="flex-end" mt="15px">
        <Button height="40px" borderLess onClick={handleModalCancel}>
          <Text>Cancel</Text>
        </Button>
        <Button
          type="primary"
          height="40px"
          width="80px"
          onClick={handleSubmitWatchlistName}
          round
        >
          <Text color={color.light} align="center">
            Create Watchlist
          </Text>
        </Button>
      </Flex>
    </Modal>
  );
}

export default CreateModal;
